import type { RequestOptions } from "../common/server";
import type { AxShareConfigModel, ExtendedSsoResponse, PromotedRelease, ResetPasswordValidateJs } from "@/generated/models";
import { objectToFormData } from "@/services/utils/formData";
import { server } from "./server";

export async function getConfig({ signal }: RequestOptions = {}) {
  const response = await server.get("user/getConfig", { signal });
  return await response.json() as AxShareConfigModel;
}

export async function getUserInfo({ signal }: RequestOptions = {}) {
  const response = await server.get("user/getUserInfo", { signal });
  return await response.json() as ExtendedSsoResponse;
}

export async function getPromotedReleases({ signal }: RequestOptions = {}) {
  const response = await server.get("user/promoted-releases", { signal });
  return await response.json() as PromotedRelease[];
}

export async function identify(_options: RequestOptions = {}) {
  await server.post("user/identify");
}

export async function deleteAccount({ signal }: RequestOptions = {}) {
  const response = await server.post("user/deleteAccount", { signal });
  return await response.json();
}

export async function validateDidNotCreateAccountToken(token: string, { signal }: RequestOptions = {}) {
  const formData = objectToFormData({ token });
  const response = await server.post("user/validateDidNotCreateAccountToken", {
    body: formData,
    signal,
  });
  return await response.json() as ResetPasswordValidateJs;
}

export async function deleteAccountByToken(token: string, { signal }: RequestOptions = {}) {
  const formData = objectToFormData({ token });
  const response = await server.post("user/deleteAccountByToken", {
    body: formData,
    signal,
  });
  return await response.json();
}
